package ai.jessie.web.members

import ai.jessie.web.onboarding.HTTP_BAD_REQUEST
import ai.jessie.web.onboarding.HTTP_CONFLICT
import ai.jessie.web.onboarding.HTTP_FORBIDDEN
import ai.jessie.web.onboarding.OnboardingProblem
import ai.jessie.web.onboarding.OnboardingRequestFailure
import ai.jessie.web.onboarding.problem

// UC-005 outcomes. Everything else keeps the UC-006 tenant-denial presentation unchanged.
internal fun OnboardingRequestFailure.memberProblem(): OnboardingProblem =
    when {
        status == HTTP_CONFLICT -> conflictProblem(code)
        status == HTTP_BAD_REQUEST && code == "INVALID_MEMBER_CHANGE" ->
            OnboardingProblem(
                "Bitte korrigiere die markierten Angaben: eine gültige E-Mail-Adresse und eine " +
                    "andere unterstützte Rolle.",
                fields.map { if (it == "email") INVITE_EMAIL_ID else INVITE_ROLE_ID },
            )
        // A1: no record or membership detail, only the neutral absence.
        status == HTTP_NOT_FOUND ->
            OnboardingProblem("Nicht verfügbar oder du hast keinen Zugriff.")
        else -> problem()
    }

private fun conflictProblem(code: String) =
    when (code) {
        "MEMBER_EXISTS" ->
            OnboardingProblem("Diese Person ist bereits Mitglied. Es wurde nichts geändert.")
        "INVITATION_EXISTS" ->
            OnboardingProblem(
                "Für diese Adresse besteht bereits eine offene Einladung. Sie ist unten markiert " +
                    "und kann erneut gesendet oder widerrufen werden."
            )
        "LAST_OWNER" ->
            OnboardingProblem(
                "Jede Organisation braucht mindestens einen Eigentümer. Es wurde nichts geändert."
            )
        else ->
            OnboardingProblem(
                "Die Mitgliedschaften haben sich inzwischen geändert. Es wurde nichts geändert; " +
                    "der aktuelle Stand wird angezeigt."
            )
    }

internal fun OnboardingRequestFailure.deniesAccess() =
    status == HTTP_UNAUTHENTICATED ||
        status == HTTP_FORBIDDEN ||
        status == HTTP_NOT_FOUND ||
        code == "ORGANISATION_REQUIRED"

internal fun OnboardingRequestFailure.notCompleted() = status == 0 || status >= HTTP_SERVER_ERROR

// A3 shows the existing invitation; A5 shows the current state.
internal fun OnboardingRequestFailure.reloadsListing() =
    status == HTTP_CONFLICT && code != "MEMBER_EXISTS" && code != "LAST_OWNER"

internal const val INVITE_EMAIL_ID = "invite-email"
internal const val INVITE_ROLE_ID = "invite-role"
private const val HTTP_UNAUTHENTICATED = 401
private const val HTTP_NOT_FOUND = 404
private const val HTTP_SERVER_ERROR = 500
